const depoimentos = [
  {
    nome: 'Camila Ferreira',
    cargo: 'Gerente de Marketing · SP',
    avatar: 'https://public.readdy.ai/ai/img_res/19f1e75b0fdb7668a39b68b712becfc2.jpg',
    antes: 'Travava antes de toda apresentação importante. Coração acelerado, branco na mente — parecia que ia desmoronar na frente de todos.',
    depois: 'Aprendi a ancorar confiança e calma em segundos. Hoje faço apresentações para C-level sem ansiedade. Meu chefe perguntou o que eu tinha feito diferente.',
    exercicio: 'Ancoragem Emocional',
    resultado: 'Ansiedade zerada em 3 semanas',
    estrelas: 5,
  },
  {
    nome: 'Renata Oliveira',
    cargo: 'Empreendedora · RJ',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20entrepreneur%20smiling%20confident%20natural%20portrait%20soft%20warm%20background%20elegant%2038%20years%20old%20business%20owner%20natural%20features&width=80&height=80&seq=ig-dep2&orientation=squarish',
    antes: 'Toda vez que estava prestes a fechar um contrato grande, eu autossabotava. Inventava um defeito, baixava o preço, fugia. Não entendia por quê.',
    depois: 'A Técnica Swish identificou o padrão de medo do sucesso que eu carregava. Em 45 dias fechei 3 contratos que antes eu teria fugido.',
    exercicio: 'Técnica Swish + Prosperidade',
    resultado: '+3 contratos fechados em 45 dias',
    estrelas: 5,
  },
  {
    nome: 'Juliana Martins',
    cargo: 'Diretora Executiva · MG',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20executive%20smiling%20confident%20natural%20portrait%20soft%20warm%20background%20elegant%2041%20years%20old%20director%20corporate%20natural%20professional&width=80&height=80&seq=ig-dep3&orientation=squarish',
    antes: 'Tinha tudo externamente — cargo, salário, família. Mas por dentro me sentia vazia e desconectada. Não sabia mais quem eu era além dos papéis que cumpria.',
    depois: 'O exercício de Propósito de Vida me reconectou com quem eu sou de verdade. Tomei decisões que mudaram minha vida inteira — profissional e pessoal.',
    exercicio: 'Propósito de Vida',
    resultado: 'Clareza e propósito restaurados',
    estrelas: 5,
  },
];

const numeros = [
  { valor: '4.200+', label: 'Mulheres transformadas' },
  { valor: '92%', label: 'Relatam resultado em 30 dias' },
  { valor: '12', label: 'Exercícios gratuitos' },
  { valor: '7 dias', label: 'Garantia de satisfação' },
];

export default function IGDepoimentos() {
  return (
    <section className="py-20 px-5 bg-luxury-black">
      <div className="max-w-lg mx-auto">
        {/* Números */}
        <div className="grid grid-cols-2 gap-3 mb-14">
          {numeros.map((n, i) => (
            <div key={i} className="bg-white/[0.03] border border-gold-500/15 rounded-2xl p-4 text-center">
              <div className="font-display text-2xl font-bold text-gold-400 mb-1">{n.valor}</div>
              <div className="text-[11px] text-white/40 leading-snug">{n.label}</div>
            </div>
          ))}
        </div>

        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/[0.04] border border-white/10 rounded-full mb-5">
            <i className="ri-double-quotes-l text-gold-400 text-sm" />
            <span className="text-[11px] font-bold text-white/50 tracking-[0.18em] uppercase">Resultados reais</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight">
            O que elas estavam <span className="text-white/40">vivendo</span><br />
            e o que <span className="text-gold-400">alcançaram</span>
          </h2>
        </div>

        {/* Cards de depoimentos */}
        <div className="space-y-5">
          {depoimentos.map((d, i) => (
            <div key={i} className="bg-white/[0.03] border border-white/[0.07] rounded-2xl overflow-hidden">
              {/* Header do card */}
              <div className="bg-gradient-to-r from-charcoal-900 to-[#1a1610] px-5 py-4 flex items-center gap-3">
                <img
                  src={d.avatar}
                  alt={d.nome}
                  className="w-11 h-11 rounded-full object-cover object-top border-2 border-gold-400/30 shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-white/90 leading-tight">{d.nome}</p>
                  <p className="text-[11px] text-gold-400/70">{d.cargo}</p>
                </div>
                <div className="flex gap-0.5 shrink-0">
                  {[...Array(d.estrelas)].map((_, si) => (
                    <i key={si} className="ri-star-fill text-gold-400 text-xs" />
                  ))}
                </div>
              </div>

              {/* Antes */}
              <div className="px-5 pt-4 pb-3 border-b border-white/[0.05]">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                    <i className="ri-arrow-down-line text-white/40 text-[10px]" />
                  </div>
                  <span className="text-[10px] font-bold text-white/30 uppercase tracking-widest">Antes</span>
                </div>
                <p className="text-xs text-white/45 leading-relaxed italic">&ldquo;{d.antes}&rdquo;</p>
              </div>

              {/* Depois */}
              <div className="px-5 py-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-5 h-5 rounded-full bg-gold-500/15 flex items-center justify-center shrink-0">
                    <i className="ri-arrow-up-line text-gold-400 text-[10px]" />
                  </div>
                  <span className="text-[10px] font-bold text-gold-500/70 uppercase tracking-widest">Depois</span>
                </div>
                <p className="text-sm text-white/75 leading-relaxed font-medium mb-3">&ldquo;{d.depois}&rdquo;</p>
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <span className="text-[11px] text-white/30">
                    Exercício: <span className="text-gold-400/70 font-semibold">{d.exercicio}</span>
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] font-bold text-emerald-300 bg-emerald-400/[0.07] border border-emerald-400/20 px-2.5 py-1 rounded-full">
                    <i className="ri-leaf-line text-xs" />
                    {d.resultado}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
